import { createAction, props } from '@ngrx/store';

export const LoadFMFScript = createAction('LOAD_FMF_SCRIPT');

export const SetFMFTId = createAction(
  'SET_FMF_TRANSACTIONID',
  props<{ payload: { transactionId: string } }>(),
);
